module.exports = __webpack_public_path__ + "media/images/category_icons/learning-4df6acbe644d4661936e02fa28c0a477.svg";